import { ActionTree } from "vuex";
import { AppState } from "./app.module";
import { RootState } from "..";
import { MUTATIONS } from "@/constants/mutations";
import { ToastModel } from "@/interfaces/app/toast-model";

let toastTimeout: ReturnType<typeof setTimeout> | undefined;
let toastSequence = 0;

export const APP_ACTIONS: ActionTree<AppState, RootState> = {
  updateToastModal(context, toast: ToastModel): void {
    if (toastTimeout) clearTimeout(toastTimeout);
    context.commit(MUTATIONS.app.updateToastModal, {
      ...toast,
      id: ++toastSequence
    });
    toastTimeout = setTimeout(() => {
      context.commit(MUTATIONS.app.dismissToast);
      toastTimeout = undefined;
    }, 5000);
  },

  dismissToast(context): void {
    if (toastTimeout) clearTimeout(toastTimeout);
    toastTimeout = undefined;
    context.commit(MUTATIONS.app.dismissToast);
  },

  toggleSidebarStatus(context): void {
    context.commit(MUTATIONS.app.toggleSidebarStatus);
  }
};
